<template>
    <div class="curved-block-line">
        <svg preserveAspectRatio="none" class="inner"  viewBox="0 0 1440 67" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect class="svg-item" :fill="bottom" x="0" y="9" width="1440" height="58"></rect>
            <path class="svg-item" :fill="line" d="M0,7.10542736e-15 L1440,7.10542736e-15 L1440,54 C1185.67398,8.7357223 943.545336,2.70245492 713.614076,35.9001978 C483.682816,69.0979408 245.811457,75.1312082 0,54 L0,7.10542736e-15 Z" ></path>
            <path class="svg-item" :fill="top" d="M0,5.32907052e-14 L1440,5.32907052e-14 L1440,24 C1225.4331,-7.433439 985.433096,-7.433439 720,24 C454.566904,55.433439 214.566904,55.433439 0,24 L0,5.32907052e-14 Z" ></path>
        </svg>
    </div>
</template>

<script>

export default {
    name: 'curved-line',
    props: {
        // in PX
        line: {
            type: String,
            default: '#3AA2C6',
        },
        bottom: {
            type: String,
            default: '#fff',
        },
        top: {
            type: String,
            default: '#fff',
        },
    },
    computed:{
       
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.curved-block-line{
    line-height: 0;
    .inner{
        width: 100%;
        height: auto;
        .svg-item{
            transition: fill 0.15s ease-in-out;
        }
    }
}
</style>